module.exports = __webpack_public_path__ + "static/media/cap_aml.a11ca24a.jpg";